export const getPlaceComponentTypeName = (
  components: google.maps.GeocoderAddressComponent[] | undefined,
  type: string,
  name: 'short_name' | 'long_name' = 'short_name',
) => {
  const foundComponent = components?.find(component => {
    const cType = component.types[0];
    if (cType === type) {
      return component;
    }
  });
  return foundComponent ? foundComponent[name] : '';
};
